module.exports = __webpack_public_path__ + "img/weather.f212817a.svg";